import React from 'react';
import { Route as WouterRoute } from 'wouter';
import type { Path, DefaultParams } from 'wouter';

type Props = {
  path: Path;
  renderComponent: (params: DefaultParams) => React.ReactNode;
};

function Route({ path, renderComponent }: Props) {
  return <WouterRoute path={path}>{(params) => renderComponent(params)}</WouterRoute>;
}

export default Route;
